import React from "react";

const HierarchyContext = React.createContext({});

export const HierarchyProvider = HierarchyContext.Provider;
export const HierarchyConsumer = HierarchyContext.Consumer;
export default HierarchyContext;
